import styles from '@styles/screens/StartDemoScreen.module.css'
import { ReactComponent as QontactTextSVG } from '@assets/SVGs/GeneralUse/Qontact.svg';
import { ReactComponent as QontactBackgroundSVG } from '@assets/SVGs/GeneralUse/QontactBackground.svg';
import { isMobile } from 'react-device-detect';
import { HorizontalContainer, VerticalContainer, VerticalSpacer } from "@components/General/Containers"
import { H2Title, Subtitle } from "@components/General/Titles"
import designSystem from "@styles/designSystem"
import { TextAreaInput, TextInput } from '@components/General/TextInput';
import { useState, useCallback, useMemo, useEffect, useRef } from 'react';
import { NormalButton } from '@components/General/Button';
import {} from "@localization/Localization"
import { useStartDemoViewModel } from '../view-models/StartDemoScreenViewModel';
import { QontactLogoPanel } from '@components/QontactLogoPanel';
import { OrangeQontactLogo } from '@components/OrangeQontactLogo';
import { MobileWrapperScreen } from './MobileWrapperScreen';
import { ErrorText } from '@components/General/Texts';

export const MobileStartDemoScreen: React.FC = () => {
    const {
        loading,
        name,
        phone,
        company,
        email,
        nameError,
        phoneError,
        companyError,
        emailError,
        serviceError,
        setLoading,
        setName,
        setPhone,
        setCompany,
        setEmail,
        validateEmail,
        validateName,
        validatePhone,
        validateCompany,
        handleSubmit,
        viewDidAppear,
    } = useStartDemoViewModel();
    // Create refs for each input
    const nameRef = useRef<any>(null)
    const emailRef = useRef<any>(null)
    const phoneRef = useRef<any>(null)
    const companyRef = useRef<any>(null)

        // Memoize the callbacks to prevent recreating them on every render
    const focusEmail = useCallback(() => emailRef.current?.focus(), [])
    const focusPhone = useCallback(() => phoneRef.current?.focus(), [])
    const focusCompany = useCallback(() => companyRef.current?.focus(), [])
    const handleFormSubmit = useCallback(() => handleSubmit(), [handleSubmit])

    // viewDidAppear - runs only once when component first mounts
    useEffect(() => {
        viewDidAppear()
    }, []) // Empty dependency array ensures this runs only once
    
    return (
        <MobileWrapperScreen>
            <VerticalContainer>
                <VerticalContainer 
                    gap={designSystem.gapNone}
                >
                    <H2Title text={"Experimenta Qontact".localized()}/>
                    <Subtitle text={"Ingresa tu nombre y número de teléfono para que puedas probar fichar vos mismo ahora!"}/>
                </VerticalContainer>
                <TextInput
                    ref={nameRef}
                    label={"Nombre".localized()}
                    placeholder={"Ingresa tu nombre completo".localized()}
                    onChange={(e) => {setName(e)}}
                    value={name}
                    loading={false}
                    error={nameError}
                    onEnterPress={focusEmail}
                />
                <TextInput
                    ref={emailRef}
                    label={"Email".localized()}
                    placeholder={"Ingresa tu email laboral".localized()}
                    onChange={(e) => {setEmail(e)}}
                    value={email}
                    onLostFocus={validateEmail}
                    loading={false}
                    error={emailError}
                    onEnterPress={focusPhone}
                    type={"email"}
                    inputMode={"email"}
                />
                <TextInput
                    ref={phoneRef}
                    label={"Número de teléfono".localized()}
                    placeholder={"ej: +5491155557788".localized()}
                    onChange={(e) => {setPhone(e)}}
                    value={phone}
                    error={phoneError}
                    onEnterPress={focusCompany}
                    type={"tel"}
                    inputMode={"tel"}
                />
                <TextInput
                    ref={companyRef}
                    label={"Empresa".localized()}
                    placeholder={"Dónde trabajas?".localized()}
                    onChange={(e) => {setCompany(e)}}
                    onEnterPress={() => { handleSubmit() }}
                    value={company}
                    error={companyError}
                />
                <VerticalContainer alignment={'center'}>
                    <NormalButton 
                        text={"Siguiente".localized()}
                        width={"100%"}
                        onClick={() => {
                            handleSubmit()
                        }} 
                        loading={loading}
                    />
                    { serviceError && 
                        <ErrorText text={serviceError}/>
                    }
                </VerticalContainer>
            </VerticalContainer>
        </MobileWrapperScreen>
    )
}